import { render, staticRenderFns } from "./TemplateTable.vue?vue&type=template&id=367ddcea"
import script from "./TemplateTable.vue?vue&type=script&lang=js"
export * from "./TemplateTable.vue?vue&type=script&lang=js"
import style0 from "./TemplateTable.vue?vue&type=style&index=0&id=367ddcea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports